'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getPhrase = {};

exports.__exports = getPhrase;
